import React from "react";
import { Link } from "react-router-dom";
import { Button } from "primereact/button";
import localeText from "../../../../../../locale";

const EconomicCirclePageHeader = () => (
  <>
    <nav
      className="flex align-items-center gap-2 mb-2 text-sm"
      style={{ color: "var(--theme-text-muted, #5C5C5C)" }}
      aria-label="Breadcrumb"
    >
      <span style={{ color: "var(--theme-text, #171717)" }}>
        {localeText("economicCircle") || "Círculo Econômico"}
      </span>
    </nav>

    <div className="flex align-items-center justify-content-between mb-4">
      <div>
        <h1 className="text-xl font-semibold m-0" style={{ color: "var(--theme-text, #171717)" }}>
          {localeText("economicCircle") || "Círculo Econômico"}
        </h1>
        <p className="text-sm m-0 mt-1" style={{ color: "var(--theme-text-muted, #5C5C5C)" }}>
          {localeText("economicCircleSubtitle") || "Acompanhe seu círculo econômico e expansão."}
        </p>
      </div>
      <Link to="/dashboard-economic-circle/invite">
        <Button
          label={localeText("invite") || "Convidar"}
          className="border-round-md border-none"
          style={{
            backgroundColor: "var(--theme-primary, #1DAF61)",
            color: "#fff",
          }}
        />
      </Link>
    </div>
  </>
);

export default EconomicCirclePageHeader;
